"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, type FC, type PropsWithChildren, use, useState } from "react";
import { useStore } from "zustand";
import { createUserStore, type UserState, type UserStore } from "~/client/services";
interface UserStoreProviderProps {
  readonly initialState: UserState;
}
type UserStoreApi = ReturnType<typeof createUserStore>;
export const UserStoreContext = createContext<UserStoreApi | undefined>(undefined);
export const UserStoreProvider: FC<PropsWithChildren<UserStoreProviderProps>> = t0 => {
  const $ = _c(5);
  const {
    children,
    initialState
  } = t0;
  let t1;
  if ($[0] !== initialState) {
    t1 = () => createUserStore(initialState);
    $[0] = initialState;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [store] = useState(t1);
  let t2;
  if ($[2] !== children || $[3] !== store) {
    t2 = <UserStoreContext value={store}>{children}</UserStoreContext>;
    $[2] = children;
    $[3] = store;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export const useUserStore = selector => {
  const store = use(UserStoreContext);
  if (!store) {
    throw new Error("useUserStore must be used within a UserStoreProvider");
  }
  return useStore(store, selector);
};